module.exports = __webpack_public_path__ + "static/img/basketballTrainingCol.7170ab4c.svg";